import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import OriginQuote from './components/OriginQuote';
import OurStory from './components/OurStory';
import Pillars from './components/Pillars';
import Together from './components/Together';
import Vision from './components/Vision';
import SelfSustaining from './components/SelfSustaining';
import WatchStory from './components/WatchStory';
import Foundation from './components/Foundation';
import Beginning from './components/Beginning';
import GetInvolved from './components/GetInvolved';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import ScrollProgress from './components/ui/ScrollProgress';

/**
 * Section order follows the client's brief end to end: About TEEEM → the
 * founding question → Our Story → Why TEEEM (the four actions) → Not a
 * Handout → The Vision → Building a Self-Sustaining Ministry → Watch the
 * Story Happen → Our Biblical Foundation → This Is Only the Beginning, which
 * closes on the brief's own three calls to action.
 */
export default function App() {
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-gold-600 focus:px-4 focus:py-2 focus:text-sm focus:text-white"
      >
        Skip to content
      </a>

      <ScrollProgress />
      <Header />

      <main id="main">
        <Hero />
        <OriginQuote />
        <OurStory />
        <Pillars />
        <Together />
        <Vision />
        <SelfSustaining />
        <WatchStory />
        <Foundation />
        <Beginning />
        <GetInvolved />
        <Newsletter />
      </main>

      <Footer />
    </>
  );
}
